import React from 'react';

// Internal Import

// External Import
import { common } from "@mui/material/colors";
import { useNavigate } from 'react-router-dom';


import { Box, Typography } from '@mui/material';




export interface UnauthorizedProps { }
export const UnauthorizedScreen: React.FC<UnauthorizedProps> = () => {

    let navigate = useNavigate();

    return (
        <Box sx={{
            flex: 1,
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            backgroundColor: common.white
        }}>
            <img
                src="/assets/images/401.png"
                loading='lazy'
                style={{ width: '30%', objectFit: 'cover' }}
            />
            <Typography
                color={common.black}
                sx={{
                    fontWeight: 'bold',
                    textAlign: 'center',
                    fontFamily: 'Montserrat',
                    textTransform: 'uppercase',
                    fontSize: { xs: 15, sm: 27.5, md: 30 },
                }}
            >
                oops...<br />
                need login!
            </Typography>
        </Box>
    )
};